import eventBus from '@/events/eventBus'

export * from '~/sites/oknanebodvere/store/cart'

import { actions as parentActions } from '~/sites/oknanebodvere/store/cart'
import eventDefinitions from '@/events/eventDefinitions'

export const actions = {
  ...parentActions,
  async ADD_TO_CART(actionContext, payload) {
    const response = await parentActions.ADD_TO_CART.call(this, actionContext, payload)

    if (response?.addedItem) {
      eventBus.$emit(eventDefinitions.PRODUCT.SELECT_ITEM, {
        addedAmount: response.changedAmount,
        item: response.addedItem,
      })
    }

    return response
  },
}
